import React, { useEffect, useState, useCallback } from 'react'

// Material-UI
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ButtonSave from '../ButtonSave/ButtonSave'
import './MarketingSectionOptions.scss'
import CustomDropdown from '../Dropdown/dropdown'
import { useErrorSnackBarContext } from '../ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../Services/serviceBase.interceptor'
import MarketingSectionOptionsActions from 'app/Components/Shared/MarketingSectionOptions/MarketingSectionOptionsActions'

const MarketingSectionOptions = React.memo(
  ({ 
    setMarketingOptions, 
    open, 
    isCreation, 
    onClose, 
    setNameToCreate, 
    setSelectedOptions, 
    isClone = false,
    nameToClone,
    setEmergencyProviderCloneName
  }) => {

    const { errorSnackBarActions } = useErrorSnackBarContext()
    Interceptor.interceptor(errorSnackBarActions)
    const listOfOptions = [
      { value: 0, text: 'All Emergency Providers' },
      { value: 1, text: 'Country' },
      { value: 2, text: 'State' },
      { value: 3, text: 'County' },
      { value: 4, text: 'Individual emergency provider' }
    ]
    const SELECT_VALUE = '0'
    const [option, setOption] = useState(SELECT_VALUE)
    const [country, setCountry] = useState(SELECT_VALUE)
    const [countries, setCountries] = useState([])
    const [state, setState] = useState(SELECT_VALUE)
    const [states, setStates] = useState([])
    const [county, setCounty] = useState(SELECT_VALUE)
    const [counties, setCounties] = useState([])
    const [emergencyProviders, setEmergencyProviders] = useState([])
    const [emergencyProvider, setEmergencyProvider] = useState(SELECT_VALUE)
    const [errorLabel, setErrorLabel] = useState('')
    const {
      getCountries,
      getStates, //do not execute until endpoint y back is done
      getCounties, //do not execute until endpoint y back is done
      getAllEmergencyProvider
    } = MarketingSectionOptionsActions

    const handleOptionsDropdownChange = useCallback((evt) => {
      const value = evt.target.value
      setOption(value)
    }, [])

    const handleCountryDropdownChange = useCallback((evt) => {
      const value = evt.target.value
      setCountry(value)
    }, [])

    const handleStateDropdownChange = useCallback((evt) => {
      const value = evt.target.value
      setState(value)
    }, [])

    const handleCountyDropdownChange = useCallback((evt) => {
      const value = evt.target.value
      setCounty(value)
    }, [])

    const handleEmergencyProviderChange = useCallback((event, option) => {
      setEmergencyProvider(option)
    }, [])

    useEffect(() => {
      async function getCountriesList() {
        let countriesResponse = await getCountries()
        if (countriesResponse && countriesResponse.length > 0) {
          setCountries(countriesResponse)
        }
      }

      async function getStateList(id) {
        let statesResponse = await getStates(id) //// execute the get for state once is finish in back

        if (statesResponse && statesResponse.length > 0) {
          setStates(statesResponse)
        }
      }

      async function getCountiesList(id, state) {
        let countiesResponse = await getCounties(id, state) //// execute the get for county once is finish in back

        if (countiesResponse && countiesResponse.length > 0) {
          setCounties(countiesResponse)
        }
      }

      async function getAllEmergencyProviderList() {
        let emergencyProviderResponse = await getAllEmergencyProvider()
        if (emergencyProviderResponse && emergencyProviderResponse.length > 0) {
          setEmergencyProviders(emergencyProviderResponse)
        }
      }

      async function fetchDrops() {
        switch (parseInt(option)) {
          case 1:
            await getCountriesList() //get the list of countries
            break
          case 2:
            if (countries.length === 0) {
              //if there is no countries first we get them
              await getCountriesList()
            }
            if (country !== SELECT_VALUE) {
              // once the user select a country we get the states
              await getStateList(parseInt(country))
            }
            break
          case 3:
            if (countries.length === 0) {
              //if there is no countries first we get them
              await getCountriesList()
            }
            if (country !== SELECT_VALUE) {
              // once the user select a country we get the states
              await getStateList(parseInt(country))
            }
            if (state !== SELECT_VALUE && country !== SELECT_VALUE) {
              await getCountiesList(parseInt(country), state)
            }
            break
          case 4:
            //get department
            await getAllEmergencyProviderList()
            break
          default:
            break
        }
      }
      fetchDrops()
    }, [county, country, option, state])

    const setNameToCreateAndValidate = () => {
      let nameToCreate = ''
      let options = {
        value:'',
        state:'',
        county:'',
        typeOfSearch:0
      }
      options.typeOfSearch = option
      switch (parseInt(option)) {
        case 0:
          nameToCreate = 'All'
          break
        case 1:
          validateCountry()
          if (country !== SELECT_VALUE) {
            nameToCreate = countries.find((el) => el.value === parseInt(country)).text
            options.country =  nameToCreate
            options.value = country
          }
          break
        case 2:
          validateState()
          validateCountry()
          if (country !== SELECT_VALUE && state !== SELECT_VALUE) {
            nameToCreate = `${countries.find((el) => el.value === parseInt(country)).text}-${state}`
            options.country =  countries.find((el) => el.value === parseInt(country)).text
            options.state = state
            options.value = country
          }
          break
        case 3:
          validateCounty()
          validateState()
          validateCountry()
          if (country !== SELECT_VALUE && state !== SELECT_VALUE && county !== SELECT_VALUE) {
            nameToCreate = `${countries.find((el) => el.value === parseInt(country)).text
              }-${state}-${county}`

            options.country =  countries.find((el) => el.value === parseInt(country)).text
            options.state = state
            options.county = county
            options.value = country
          }
          break
        case 4:
          validateEmergencyProvider()
          if (emergencyProvider !== SELECT_VALUE) {
            nameToCreate = `${emergencyProvider.value}`
            options.value = emergencyProvider.value
          }
          break
        default:
          break
      }
      setSelectedOptions(options)
      return nameToCreate
    }

    const AcceptOptions = () => {
      let nameToCreate = setNameToCreateAndValidate()
      setMarketingOptions({
        country,
        county,
        state,
        emergencyProviderName: emergencyProvider.text
      })
      if (nameToCreate) {
        setNameToCreate(nameToCreate)
        onClose()
      }
      //Open dialog here with the text and the id if has a id
    }

    const validateCountry = () => {
      if (country === SELECT_VALUE) {
        setErrorLabel('You need to select a country')
      }
    }

    const validateState = () => {
      if (state === SELECT_VALUE) {
        setErrorLabel('You need to select a state')
      }
    }

    const validateCounty = () => {
      if (county === SELECT_VALUE) {
        setErrorLabel('You need to select a county')
      }
      return county === SELECT_VALUE
    }

    const validateEmergencyProvider = () => {
      if (emergencyProvider === SELECT_VALUE) {
        setErrorLabel('You need to select an emergency provider')
      }
      return emergencyProvider === SELECT_VALUE
    }

    useEffect(() => {
      if (errorLabel !== '') {
        errorSnackBarActions.setOpen(true, errorLabel)
        setErrorLabel('')
      }
    }, [errorLabel, errorSnackBarActions])

    const SearchOptions = () => {
      let nameToCreate = setNameToCreateAndValidate()
      if (nameToCreate) {
        setNameToCreate(nameToCreate)
        onClose()
      }
    }

    return (
      <div>
        <Dialog className="news-dialog" disableBackdropClick disableEscapeKeyDown open={open}>
          <DialogTitle className="news-dialog-title">
            <span>Configuration Mode</span>
            <IconButton aria-label="close" className="close-button" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="news-dialog-content">
            <Grid container>
              <form noValidate autoComplete="off">
                <Grid size={12}>
                  {isClone ?
                    <Grid size={12}>
                      <label>You're cloning: {nameToClone}</label>
                    </Grid>
                    : <></>
                  }
                  <Grid size={12}>
                    <div className="container-field dropdown-container">
                      <div>
                        <label htmlFor="positionFiles">Options</label> <br />
                        <CustomDropdown
                          name="positionFiles"
                          value={option}
                          list={listOfOptions}
                          onChange={handleOptionsDropdownChange}
                        />
                      </div>
                    </div>
                  </Grid>
                  {option === SELECT_VALUE ? (
                    <Grid size={12}>
                      On the combo box we will add the next options:
                      <div className="container-field option-labels-container">
                        <label htmlFor="positionFiles">1. All Emergency providers</label> <br />
                        <label htmlFor="positionFiles">2. Country</label> <br />
                        <label htmlFor="positionFiles">3. State</label> <br />
                        <label htmlFor="positionFiles">4. County</label> <br />
                        <label htmlFor="positionFiles">5. Individual Emergency provider</label>{' '}
                        <br />
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  {['1', '2', '3'].indexOf(option) > -1 ? (
                    <Grid size={12}>
                      <div className="container-field dropdown-container">
                        <div>
                          <label htmlFor="dropCountries">Country</label> <br />
                          <CustomDropdown
                            name="country"
                            value={country}
                            list={countries}
                            onChange={handleCountryDropdownChange}
                          />
                        </div>
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  {['2', '3'].indexOf(option) > -1 && country !== SELECT_VALUE ? (
                    <Grid size={12}>
                      <div className="container-field dropdown-container">
                        <div>
                          <label htmlFor="dropStates">States</label> <br />
                          <CustomDropdown
                            name="states"
                            value={state}
                            list={states}
                            onChange={handleStateDropdownChange}
                          />
                        </div>
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  {['3'].indexOf(option) > -1 &&
                    country !== SELECT_VALUE &&
                    state !== SELECT_VALUE ? (
                    <Grid size={12}>
                      <div className="container-field dropdown-container">
                        <div>
                          <label htmlFor="dropStates">County</label> <br />
                          <CustomDropdown
                            name="counties"
                            value={county}
                            list={counties}
                            onChange={handleCountyDropdownChange}
                          />
                        </div>
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  {['4'].indexOf(option) > -1 ? (
                    <Grid size={12}>
                      <div className="container-field autocomplete-container">
                        <div>
                          <label htmlFor="positionFiles">Emergency Provider</label> <br />
                          <div className="customAutocomplete">
                            <Autocomplete
                              id="emergencyProvider"
                              options={emergencyProviders}
                              getOptionLabel={(option) => option.text}
                              renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                              onChange={handleEmergencyProviderChange}
                              sx={{ '& .MuiAutocomplete-popupIndicator span svg path': { d: "path('M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z')" } }}
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid container>
                    <Grid size={12} className="container container-buttons">
                      <div className="save-button-container">
                        <ButtonSave
                          id="saveButton"
                          text={isClone ? 'Clone' : isCreation ? 'Accept' : 'Search'}
                          onClickCallback={ (isClone || isCreation) ? AcceptOptions : SearchOptions}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    )
  }
)

export default MarketingSectionOptions
